<template>
    <div class="modal fade show modal-style " aria-labelledby="addNewCardTitle">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-items-center">
                            <h3 class="mb-0">Filter</h3>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>
                <hr class="mt-0 mb-0">
                <div class="pb-2">
                    <div class="row py-1 mx-auto">
                        <div class="d-flex gap-1 align-items-center">
                            <label for="no-of-decimals" class="text-nowrap">No of decimals: </label>
                            <input
                                class="form-control w-25"
                                v-model="noOfDecimals"
                                type="number"
                                min="0"
                                max="4"
                                @blur="validateNoOfDecimals"
                            />
                        </div>
                        <div class="d-flex gap-1 align-items-center mt-2">
                            <label class="text-nowrap">Show Zero: </label>
                            <label for="show-non-zero">
                                <input
                                    type="radio"
                                    id="show-non-zero"
                                    name="show-non-zero"
                                    :checked="!showNonZero"
                                    @change="() => {showNonZero = 0}"
                                />
                                Yes
                            </label>
                            <label for="show-zero">
                                <input
                                    type="radio"
                                    id="show-zero"
                                    name="show-non-zero"
                                    :checked="showNonZero"
                                    @change="() => {showNonZero = 1}"
                                />
                                No
                            </label>
                        </div>
                        <div class="d-flex gap-1 align-items-center mt-2">
                            <label class="text-nowrap">Account Code: </label>
                            <label for="show-account-code">
                                <input
                                    type="radio"
                                    id="show-account-code"
                                    name="show-account-code"
                                    :checked="showAccountCode"
                                    @change="() => {showAccountCode = 1}"
                                />
                                Show
                            </label>
                            <label for="hide-account-code">
                                <input
                                    type="radio"
                                    id="hide-account-code"
                                    name="show-account-code"
                                    :checked="!showAccountCode"
                                    @change="() => {showAccountCode = 0}"
                                />
                                Hide
                            </label>
                        </div>
                    </div>
                </div>
                <div class="pb-1 px-2">
                    <div class="d-flex justify-content-end">
                        <button class="btn btn-primary" type="button" @click="onCLickGo">Go</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import {useStore} from "vuex";
    import {inject, ref} from "vue";
    import {useRoute, useRouter} from "vue-router";

    const showError =  inject('showError');
    const emit = defineEmits(['onFilter']);
    const store = useStore();
    const route = useRoute();

    const noOfDecimals = ref(route.query.decimals ? parseInt(route.query.decimals) : 2);
    const showNonZero = ref(route.query.show_non_zero ? parseInt(route.query.show_non_zero) : 1);
    const showAccountCode = ref(getInitialShowAccountCode());

    function getInitialShowAccountCode() {
        if (route.query.show_account_code === undefined) return 0
        return parseInt(route.query.show_account_code)
    }

    const onClickClose = () => {
        store.state.isModalOpen = false;
    }

    const validateNoOfDecimals = () => {
        if (noOfDecimals.value < 0) {
            noOfDecimals.value = 0;
            showError('Decimals can not be less than 0');
            return;
        }

        if (noOfDecimals.value > 4) {
            noOfDecimals.value = 4;
            showError('Decimals must be less than 4');
        }
    }

    const onCLickGo = () => {
        emit("onFilter", {
            decimals: noOfDecimals.value,
            showNonZero: showNonZero.value,
            showAccountCode: showAccountCode.value,
        });
        onClickClose();
    }

</script>

<style scoped>
.modal-style {
    display: block;
    background: #1c1d1c33
}
</style>